import { render } from "./11.vue?vue&type=template&id=56206be2"
import script from "./11.vue?vue&type=script&lang=js"
export * from "./11.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__